const init = () => {

    document.addEventListener('DOMContentLoaded', function() {
        var $component = $('.c-book-details');
        if (!$component.length) return;

        var $hiRes = $component.find('.c-book-details__magnify');
        var $lookInside = $('.page-content > .look-inside');
        var viewer;

        const description = $component.find('.c-book-details__desc');
        
        // book page 'Hi-Res Cover' link - attach this before any early returns
        $hiRes.click(function(e) {
            e.preventDefault();
            var lightbox = penguinModal($(this).attr('href'));
        });
        
        // Check if the description element exists before proceeding
        if (!description.length) {
            // This is not a book detail page with description, exit early
            return;
        }
        
        // Now set up the transition and initial state
        description.css('transition', 'height 0.3s ease-in-out');
        
        // Remove any existing inline height styles to start fresh
        description.css('height', '');
        
        // Function to get the appropriate collapsed height based on screen size
        const getCollapsedHeight = () => {
            const windowWidth = $(window).width();
            if (windowWidth < 768) { // Mobile
                return '284px';
            } else if (windowWidth < 1024) { // Tablet
                return '384px';
            } else { // Desktop
                return '336px';
            }
        };
        
        // Function to get the natural (full) height of the content
        const getNaturalHeight = () => {
            // Temporarily remove all height constraints to get the true natural height
            const currentHeight = description.css('height');
            const currentMaxHeight = description.css('max-height');
            const currentOverflow = description.css('overflow');
            
            // Set to auto to unconstrain the element
            description.css({
                'height': 'auto',
                'max-height': 'none',
                'overflow': 'visible'
            });
            
            // Force a reflow to ensure accurate measurement
            description[0].offsetHeight;
            
            const naturalHeight = description[0].scrollHeight;
            
            // Restore the previous styles
            description.css({
                'height': currentHeight,
                'max-height': currentMaxHeight,
                'overflow': currentOverflow
            });
            
            return naturalHeight;
        };

        // Get the natural height after clearing constraints and store it
        const naturalHeight = getNaturalHeight();

        if (naturalHeight < 300) {
            description.addClass('is-short');
            // For short content, don't restrict height
            description.css('height', 'auto');
        } else {
            // For long content, start collapsed
            description.css('height', getCollapsedHeight());
        }

        var $readMoreButton = $component.find('.c-book-details__read-more');
        
        // Ensure button text matches current state
        if (description.hasClass('is-open')) {
            $readMoreButton.text('Read less');
        } else {
            $readMoreButton.text('Read more');
        }
        $readMoreButton.on('click', function() {
            if (description.hasClass('is-open')) {
                description.removeClass('is-open');
                description.css('height', getCollapsedHeight());
                $readMoreButton.text('Read more');
            } else {
                description.addClass('is-open');
                // Recalculate natural height to ensure accuracy
                const currentNaturalHeight = getNaturalHeight();
                description.css('height', currentNaturalHeight + 'px');
                $readMoreButton.text('Read less');
            }
        });

        // Handle window resize to update collapsed height if needed
        $(window).on('resize', function() {
            if (!description.hasClass('is-open') && !description.hasClass('is-short')) {
                description.css('height', getCollapsedHeight());
            }
        });

        // Initialize look inside functionality when DOM is ready
        function initializeLookInside() {
            if (window.lookInsideProps && !window.lookInsideProps.isHidden) {
                $.getScript('https://books.google.com/books' + lookInsideProps.query, onGotBooksApi);
            } else {
            }
        }
        
        // Initialize immediately if DOM is ready, otherwise wait for it
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', initializeLookInside);
        } else {
            // DOM is already ready
            setTimeout(initializeLookInside, 100); // Small delay to ensure other components are initialized
        }

        function onGotBooksApi() {
            
            var $parent = $('.c-book-details__nav');
            
            var foundPreview = false;
            for (var isbn in _GBSBookInfo) {
                var b = _GBSBookInfo[isbn];
                if (b && (b.preview === 'full' || b.preview === 'partial')) {
                    var $link = $('<button class="c-book-details__look-inside" type="button"><span>Look inside</span></button>')
                    $link.attr('data-isbns', lookInsideProps.isbns);
                    $parent.prepend($link);
                    foundPreview = true;
                    break;
                }
            }
            
            // If no Google Books preview found, check for custom look inside images
            if (!foundPreview) {
                var customLookInsideButton = $('.c-look-inside__toggle');
                if (customLookInsideButton.length > 0) {
                    customLookInsideButton.show();
                } else {
                }
            }
            $.getScript('https://www.google.com/books/jsapi.js', function() {
                try {
                    google.books.load();
                    
                    // Wait for the Google Books API to be fully loaded
                    google.books.setOnLoadCallback(function() {
                        window.addEventListener('resize', resizeViewer);
                        $component.find('.c-book-details__look-inside').click(onLookInsideClick);
                        
                        // Listen for modal close to clean up viewer
                        document.addEventListener('penguin-modal:closed', function() {
                            if (viewer) {
                                try {
                                    viewer.dispose();
                                    viewer = undefined;
                                } catch (e) {
                                    // Ignore disposal errors
                                }
                            }
                        });
                    });
                } catch (error) {
                    console.error('Error initializing Google Books API:', error);
                    // Fall back to custom look inside images if available
                    var customLookInsideButton = $('.c-look-inside__toggle');
                    if (customLookInsideButton.length > 0) {
                        customLookInsideButton.show();
                    }
                }
            }).fail(function() {
                console.error('Failed to load Google Books API script');
                // Fall back to custom look inside images if available
                var customLookInsideButton = $('.c-look-inside__toggle');
                if (customLookInsideButton.length > 0) {
                    customLookInsideButton.show();
                }
            });
        }

        function resizeViewer(msg, breakpoint) {
            var widthMod = 0.87;
            var heightMod = 0.87;

            $lookInside
                .width(window.app.state.winWidth * widthMod)
                .height(window.app.state.winHeight * heightMod);
            if (viewer) viewer.resize();
        };


        function onLookInsideClick(e) {
            var $that = $(this);

            // check
            if (!$that.attr('data-isbns')) return;

            // Ensure Google Books API is loaded before proceeding
            if (typeof google === 'undefined' || typeof google.books === 'undefined' || typeof google.books.DefaultViewer === 'undefined') {
                console.warn('Google Books API not loaded yet');
                return;
            }

            resizeViewer();

            var isbns = _.map($that.data('isbns'), function(isbn) {
                return 'ISBN:' + isbn;
            });  

            // Always create a fresh viewer to ensure clean state
            if (viewer) {
                // Clean up existing viewer
                try {
                    viewer.dispose();
                } catch (e) {
                    // Ignore disposal errors
                }
            }
            
            // Create new viewer
            try {
                viewer = new google.books.DefaultViewer($lookInside.get(0));
                viewer.load(isbns, function() {
                    // Success callback
                }, function() {
                    // Error callback
                });
            } catch (error) {
                console.error('Error creating Google Books viewer:', error);
                return;
            }
            
            var lightbox = penguinModal($lookInside);
        }

        if ($('.c-editions .swiper-slide').length < 4) {
            $('.c-editions .swiper-wrapper').addClass('swiper-wrapper--centered');
        }

        // AddThis configuration
        if (typeof a2a_config !== 'undefined') {
            a2a_config.onclick = 1;
            a2a_config.prioritize = ['facebook', 'x', 'linkedin', 'whatsapp', 'email'];
        }
    });
}

export default init;